import { useNewVersion } from '../hooks/useNewVersion';

/** Vedvarende besked under topbaren, når en ny frontend er deployet. */
export function NewVersionBanner() {
  const hasNew = useNewVersion();
  if (!hasNew) return null;
  return (
    <div className="new-version-banner" role="status">
      <span>Der er kommet en ny version af HBCare Planner.</span>
      <button type="button" className="btn btn-secondary" onClick={() => window.location.reload()}>
        Genindlæs
      </button>
    </div>
  );
}
